export const CLOUDINARY_CONFIG = {
  cloudName: (process.env as any).REACT_APP_CLOUDINARY_CLOUD_NAME || 'exsportia-ltd',
  uploadPreset: (process.env as any).REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'exsportia_default',
};

export const validateCloudinaryConfig = () => {
  const errors: string[] = [];
  if (!CLOUDINARY_CONFIG.cloudName) {
    errors.push('REACT_APP_CLOUDINARY_CLOUD_NAME is not set');
  }
  if (!CLOUDINARY_CONFIG.uploadPreset) {
    errors.push('REACT_APP_CLOUDINARY_UPLOAD_PRESET is not set');
  }
  if (errors.length > 0) {
    console.error('Cloudinary configuration errors:', errors);
    return false;
  }
  return true;
};

export const UPLOAD_WIDGET_CONFIG = {
  maxFiles: 1,
  cropping: true,
  multiple: false,
  minImageWidth: 100,
  minImageHeight: 100,
  showPoweredBy: false,
  resourceType: 'image',
  croppingAspectRatio: 1,
  croppingShape: 'circle' as const,
  showSkipCropButton: false,
  showCompletedButton: true,
  showAdvancedOptions: false,
  showUploadMoreButton: false,
  croppingShowDimensions: true,
  maxFileSize: 10485760, // 10MB as "sane max size"
  croppingValidateDimensions: true,
  croppingDefaultSelectionRatio: 0.1,
  sources: ['local', 'camera', 'url'],
  clientAllowedFormats: ['jpg', 'jpeg', 'png', 'webp'], // No gif as per request
};
